import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import logger from 'src/utils/logger/logger';


class ManifestLanguagesTask extends AbstractRequestTask {

  constructor(manifest) {
    super();
    this._manifest = manifest;
  }

  getMethod() {
    return 'GET';
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    return `${getAppConfig().end_point_middleware}manifest-languages?manifest=${this._manifest}`;
  }

  getParams() {
    return {};
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {
    logger.debug('ManifestLanguagesTask isValid ', data);
    return true;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default ManifestLanguagesTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/video/ManifestLanguagesTask.js